import React from 'react';
import { Trans } from 'translations';
import Notification from 'components/notification';

export default function CmsError() {
    return (
        <div className="cms-error">
            <Notification facet="error">
                <Trans path="cms.content.error"/>
            </Notification>
        </div>
    );
}







// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/cms-error/index.js